import { Injectable } from '@angular/core';
import { SignStatus } from 'src/app/pages/main/module/engineering-application/components/model/SignStatus';
import { FormApplyDetail } from 'src/app/sdk/models';
import { VwFindSigndataControllerService } from 'src/app/sdk/services';

@Injectable({
  providedIn: 'root'
})
export class WaittingSignCountService {
  constructor(
    private vwFindSigndataControllerService: VwFindSigndataControllerService,
  ) { }

  /**
   * @description 查询待签核|待预约|待制定数量
   * @returns {*} {Promise<number>}
   */
  public async getStepWaittingCount(step: number, projectCategory?: number): Promise<number> {
    let stepWaittingCount: number = 0;
    const userId: string = localStorage.getItem('userid').length > 7 ? localStorage.getItem('userid') : localStorage.getItem('userid').slice(0, -1);
    // 1.构建参数
    const findSignDataInputBySteps: FindSignDataInput = {
      emplid: userId,
      signStep: step,
      status: 0,
    };

    let result = await this.vwFindSigndataControllerService.findSignData({
      body: findSignDataInputBySteps
    }).toPromise<FindSignDataOuput>();
    if (!!result[0]) {
      if (projectCategory !== undefined) {
        Object.keys(result[0]).forEach(key => {
          /* 
            projectCategory=0是一般工程,一般工程-->概算审核
            projectCategory=1是专案工程,专案工程-->标单审核 
          */
          if (result[0][key]['formApplyDetail']['projectCategory'] === projectCategory) {
            stepWaittingCount++;
          }
        });
      }
      else {
        stepWaittingCount = Object.keys(result[0]).length;
      }
    }
    return stepWaittingCount;
  }
}

export interface FindSignDataInput {
  emplid: string, /// 工号
  /* signStep = 1, 查询 项目管理签核
  signStep = 2, 查询 部级签核
  signStep = n, 查询xx签核 */
  signStep: number,
  /* status = 0 表示待签
  status = 1 表示已签
  status = 2 表示驳回 */
  status: 0,
}

export interface FindSignDataOuput {
  [index: number]: {
    [property: string]: {
      applicant: {
        emplid: string,
        name: string,
        applayTime: string,
      },
      formApplyDetail: FormApplyDetail,
      signStatus: SignStatus[],
    }
  }
}